import script from "./ImportBusiness.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportBusiness.vue?vue&type=script&setup=true&lang=js"

import "./ImportBusiness.vue?vue&type=style&index=0&id=137f220e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-137f220e"]])

export default __exports__